import ProjectCard from "../components/ProjectCard";

function Projects() {
	const projects = [
		{
			title: "Data Center Construction",
			image: "/images/datacenter.jpg",
			description:
				"Turnkey data center with structured cabling and backup power.",
		},
		{
			title: "Corporate ICT Upgrade",
			image: "/images/ict-upgrade.jpg",
			description: "Server deployment and office network infrastructure.",
		},
		{
			title: "Solar Power Installation",
			image: "/images/solar-installation.jpg",
			description: "10kVA solar inverter system for a financial institution.",
		},
		{
			title: "Tower Construction",
			image: "/images/tower-construction.jpg",
			description: "60m telecom tower for broadband internet provider.",
		},
	];

	return (
		<div className="p-8">
			<h2 className="text-4xl font-bold mb-6">Our Projects</h2>
			<div className="grid md:grid-cols-2 gap-6">
				{projects.map((project, index) => (
					<ProjectCard key={index} {...project} />
				))}
			</div>
		</div>
	);
}

export default Projects;
